<template>
  <div class="registration-form__step registration-form-step-target-group">
    <radio-group-fi
      v-model="targetGroup"
      class="registration-form__step__container registration-form-step-target-group__container"
      name="example"
      text-attribute="title"
      variant="hidden-icon"
      :options="targetGroupList"
      no-style
      required
    >
      <template #default="{ option, isChecked }">
        <div class="registration-form-step-target-group__image-container">
          <div class="registration-form-step-target-group__image">
            <cloud-image-fi
              v-if="targetGroupImage(option.title)"
              :src="targetGroupImage(option.title)"
              :alt="option.title"
              :aspect-ratio="1.778"
              data-test="target-group-image"
              no-drag
            />
          </div>
        </div>
        <div class="registration-form-step-target-group__title">
          <span
            :class="{
              'registration-form-step-target-group__checkbox': true,
              'registration-form-step-target-group__checkbox--checked': isChecked,
            }"
            type="radio"
            role="radio"
            :aria-checked="isChecked"
          />
          {{ option.title }}
        </div>
      </template>
    </radio-group-fi>
  </div>
</template>

<script>
import { CloudImageFi, RadioGroupFi } from 'atoms';

import { getSelectList } from '@/utils/fieldTransformations';

export default {
  name: 'RegistrationStepTargetGroup',
  components: {
    CloudImageFi,
    RadioGroupFi,
  },
  inject: ['fields'],
  emits: ['valid-changed'],
  computed: {
    targetGroup: {
      get() {
        if (this.$store.getters['registration/getTargetGroup'] !== '') {
          return this.$store.getters['registration/getTargetGroup'];
        }
        return null;
      },
      set(targetGroup) {
        const selectedTargetGroup = this.targetGroupList.find((s) => s.value === targetGroup);

        this.$store.dispatch('registration/setTargetGroup', targetGroup);
        this.$store.dispatch('registration/setTargetGroupTitle', selectedTargetGroup.title);
        this.$store.dispatch(
          'registration/setTargetGroupNewsletter',
          selectedTargetGroup.newsletter,
        );
        this.validate();
      },
    },
    targetGroupList() {
      const [, targetGroupList] = getSelectList(this.fields, 'targetGroupSectorList');
      return targetGroupList;
    },
  },
  mounted() {
    this.validate();
  },
  methods: {
    targetGroupImage(title) {
      if (this.targetGroupList) {
        const currentTarget = this.targetGroupList.find((s) => s.title === title);
        if (currentTarget?.image?.src) {
          return currentTarget.image.src;
        }
      }

      return null;
    },
    validate() {
      this.isValid = false;

      if (this.targetGroup && this.targetGroup !== '') {
        this.isValid = true;
      }

      this.$emit('valid-changed', this.isValid);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './registration-step-target-group';
</style>
